import React from 'react';
import { Link } from 'react-router-dom';
import { Target, MessageCircle, TrendingUp, Zap, Smartphone, Search, Code, Instagram } from 'lucide-react';
import './Home.css';
import heroImg from '../assets/images/hero.png';
import aboutImg from '../assets/images/about.jpg';

function Home() {
    return (
        <div className="home-page">
            <section className="hp-hero">
                <div className="hp-hero-text">
                    <div className="hp-badge hp-badge-blue">
                        <span className="dot"></span>MARKETING A WEBOVÝ DESIGN
                    </div>
                    <h1 className="hp-h1">Přestaňte zkoušet. Začněte řídit.</h1>
                    <p className="hp-sub" style={{ whiteSpace: 'pre-line' }}>
                        {"Propojuji strategii, web a výkon do jednoho systému, který přináší výsledky.\nPro firmy, které chtějí růst řízeně, ne náhodou."}
                    </p>
                    <div className="hp-hero-cta">
                        <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Rezervovat konzultaci</a>
                    </div>
                </div>
                <div className="hp-hero-image-wrapper">
                    <img src={heroImg} alt="Andrea Lišková" className="hp-hero-img" />
                </div>
            </section>

            <section className="hp-services">
                <div className="hp-services-header">
                    <div className="hp-label">SLUŽBY</div>
                    <h2 className="hp-h2">Marketing postavený na rozhodnutí, ne na dojmech.</h2>
                    <p className="hp-sub">Bez chaosu. Bez improvizace. Jen systém, který funguje.</p>
                </div>
                <div className="hp-services-cards">
                    <div className="hp-card">
                        <div className="hp-card-icon bg-blue-light color-blue">
                            <Target size={28} />
                        </div>
                        <h3 className="hp-card-title color-dark">Strategie růstu</h3>
                        <p className="hp-card-desc color-gray">
                            {"Bez směru není růst.\n Pomohu vám nastavit jasnou marketingovou strategii postavenou na datech, prioritách a konkrétních cílech.\n Žádné náhodné kampaně. Jen rozhodnutí, která dávají smysl."}
                        </p>
                        <Link to="/strategie" className="color-blue" style={{ marginTop: 'auto', fontWeight: '600', textDecoration: 'none' }}>Více o strategii &rarr;</Link>
                    </div>
                    <div className="hp-card bg-blue">
                        <div className="hp-card-icon bg-white-light color-white">
                            <MessageCircle size={28} />
                        </div>
                        <h3 className="hp-card-title color-white">Web který prodává</h3>
                        <p className="hp-card-desc color-white-opacity">
                            {"Web není vizitka. Je to obchodník.\n Navrhnu a postavím web, který jasně komunikuje hodnotu, vede návštěvníka k akci a podporuje váš obchodní cíl."}
                        </p>
                        <Link to="/web" className="color-white" style={{ marginTop: 'auto', fontWeight: '600', textDecoration: 'none' }}>Více o webech &rarr;</Link>
                    </div>
                    <div className="hp-card">
                        <div className="hp-card-icon bg-blue-light color-blue">
                            <TrendingUp size={28} />
                        </div>
                        <h3 className="hp-card-title color-dark">Výkon a optimalizace</h3>
                        <p className="hp-card-desc color-gray">
                            {"Výsledky nejsou náhoda.\n Jsou důsledkem správného nastavení, měření a průběžné optimalizace.\n Pomohu vám získat kontrolu nad výkonem i rozpočtem."}
                        </p>
                        <Link to="/vykon" className="color-blue" style={{ marginTop: 'auto', fontWeight: '600', textDecoration: 'none' }}>Více o výkonu &rarr;</Link>
                    </div>
                </div>
            </section>

            <section className="hp-webdev">
                <div className="hp-webdev-content">
                    <div className="hp-webdev-left">
                        <div className="hp-badge hp-badge-blue">
                            <span className="dot"></span>TVORBA WEBOVÝCH STRÁNEK
                        </div>
                        <h2 className="hp-h2">Tvorba webových stránek</h2>
                        <div className="hp-sub-content">
                            <p className="hp-sub-lh" style={{ marginBottom: '8px', whiteSpace: 'pre-line' }}>
                                {"Web není jen designový projekt. Je to obchodní nástroj.\nNavrhuji a stavím weby, které:"}
                            </p>
                            <ul className="hp-sub-list">
                                <li>jasně komunikují hodnotu</li>
                                <li>vedou návštěvníka k akci</li>
                                <li>jsou rychlé, měřitelné a připravené na růst</li>
                            </ul>
                        </div>
                        <div className="hp-webdev-cta" style={{ marginTop: '12px' }}>
                            <Link to="/web" className="btn btn-primary">Chci nový web</Link>
                        </div>
                    </div>
                    <div className="hp-webdev-right">
                        <div className="hp-feature">
                            <Zap size={24} className="color-blue" />
                            <div className="hp-feature-text">
                                <h4>Rychlost</h4>
                                <p>Web je optimalizovaný tak, aby se načítal rychle a zbytečně<br />neztrácel návštěvníky.</p>
                            </div>
                        </div>
                        <div className="hp-feature">
                            <Smartphone size={24} className="color-blue" />
                            <div className="hp-feature-text">
                                <h4>Responzivní design</h4>
                                <p>Perfektní na mobilu i desktopu</p>
                            </div>
                        </div>
                        <div className="hp-feature">
                            <Search size={24} className="color-blue" />
                            <div className="hp-feature-text">
                                <h4>Viditelnost dnes i v budoucnu</h4>
                                <p>Web je postavený tak, aby byl čitelný pro Google i nové AI systémy.</p>
                            </div>
                        </div>
                        <div className="hp-feature">
                            <Code size={24} className="color-blue" />
                            <div className="hp-feature-text">
                                <h4>Stabilní technický základ</h4>
                                <p>Bez zbytečných pluginů, bez závislosti na šablonách.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section className="hp-about">
                <div className="hp-about-img-wrapper">
                    <img src={aboutImg} alt="Andrea Lišková" className="hp-about-img" />
                </div>
                <div className="hp-about-text">
                    <div className="hp-label">O MNĚ</div>
                    <h2 className="hp-h2">Něco o mě</h2>
                    <p className="hp-sub-lh">
                        {"Jmenuji se Andrea Lišková a marketingu a e-commerce se věnuji více než 15 let.\n\nVedla jsem marketingové strategie pro silné B2C i B2B značky, zvyšovala online prodeje a podílela se na získání ocenění jako Shop roku nebo Mastercard Obchodník roku.\n Viděla jsem marketing ve velkých strukturách i v menších firmách — a vím, kde vzniká chaos.\nDnes pracuji s malými a středními firmami, které chtějí mít marketing pod kontrolou. Pomáhám jim nastavit systém, jasné priority a rozhodovat se na základě dat, ne pocitů.\n\nPokud projekt vyžaduje širší záběr, zapojuji ověřené specialisty napříč vývojem, výkonem i obsahem.\n\nMarketing není o aktivitě. Je o směru."}
                    </p>
                </div>
            </section>

            <section className="hp-cta-section">
                <h2 className="hp-cta-title">Připraveni začít řídit svůj business?</h2>
                <p className="hp-cta-sub">
                    {"Marketing a web nejsou dvě věci.\n Jsou to části jednoho systému, který musí fungovat."}
                </p>
                <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-white">
                    Domluvit strategický call
                </a>
            </section>
        </div>
    );
}

export default Home;
